import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
    selector:   '[vVar]',
    standalone: true,
})
export class VVarDirective {
    @Input() set vVar(context: unknown) {
        this.context.$implicit = this.context.vVar = context;

        if (!this.hasView) {
            this.vcRef.createEmbeddedView(this.templateRef, this.context);
            this.hasView = true;
        }
    }

    private context: {
        $implicit: unknown;
        vVar: unknown;
    } = {
        $implicit: null,
        vVar:      null,
    };

    private hasView: boolean = false;

    constructor(
        private templateRef: TemplateRef<unknown>,
        private vcRef: ViewContainerRef
    ) {}
}
